// extracted by mini-css-extract-plugin
export default {"wrapper":"Xm-z","reviewFormSuccess":"Ym-z","header":"Zm-z","message":"_m-z","paragraph":"an-z","lottieContainer":"bn-z"};